module.exports = __webpack_public_path__ + "static/img/p3-2.eab7272.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p3-2.jpg
// module id = YB8v
// module chunks = 1